export enum OrderStatusReason {
  // Default statuses
  FakeReceipt = 'fake_receipt',
  RepeatPayment = 'repeat_payment',
  DifferentAmount = 'different_amount',
  VerificationExpired = 'verification_expired',
  WrongRequisites = 'wrong_requisites',
  WaitingMerchant = 'waiting_merchant',
  WaitingTrader = 'waiting_trader',
  // Additional statuses
  PaymentNotReceived = 'payment_not_received', // Payment not received
  StatementRequired = 'statement_required', // Statement required
  VideoRequired = 'video_required', // Video required
  StatementProvidedWithin3Days = 'statement_provided_within_3_days', // Statement will be provided within 3 days
  IncorrectRequisites = 'incorrect_requisites', // Incorrect requisites
  AppealDeadlineExpired = 'appeal_deadline_expired', // Appeal deadline expired
  AccountBlockedStatementRequired = 'account_blocked_statement_required', // Account blocked, statement required
  AttachSuccessfulReceipt = 'attach_successful_receipt', // Attach successful receipt
  TransferToWrongBank = 'transfer_to_wrong_bank', // Transfer to wrong bank
  FakeReceiptOrStatement = 'fake_receipt_or_statement', // Fake receipt or statement
  PaymentConfirmationMissing = 'payment_confirmation_missing', // Payment confirmation missing
}
